// src/components/SEO/SEO.tsx
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
  url?: string;
  image?: string;
  type?: string;
}

const SEO: React.FC<SEOProps> = ({ 
  title, 
  description, 
  url = 'https://mahi-bayan.netlify.app/',
  image = 'https://mahi-bayan.netlify.app/og-image.png',
  type = 'website'
}) => {
  const fullTitle = `${title} - Mâhî Bâyân`;
  
  return (
    <Helmet>
      {/* Titre de la page */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Mâhî Bâyân" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Telegram */}
      <meta name="telegram:card" content="summary_large_image" />
      <meta name="telegram:image" content={image} />
    </Helmet>
  );
};

export default SEO;